import { defineSlotRecipe } from '@chakra-ui/react';

export const averageRatingSlotRecipe = defineSlotRecipe({
    slots: ['container', 'ratingNumerical', 'ratingDescription', 'ratingCount'],
    base: {
        container: {
            alignItems: 'center',
            alignSelf: 'flex-end',
            gap: 2,
        },
        ratingNumerical: {
            backgroundColor: 'secondary.solid',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            flex: '0 0 auto',
            height: 8,
            minWidth: 8,
            px: 1,
            fontSize: 'xs',
            alignItems: 'center',
            fontWeight: 'bold',
            borderRadius: 4,
        },
        ratingDescription: {
            fontWeight: 'bold',
            fontSize: 'sm',
        },
        ratingCount: {
            fontSize: 'xs',
            color: 'gray.500',
        },
    },
});
